<build-section
  [disabled]="disabled"
  [active]="active"
  [title]="(isPieces ? ('cakeBuilder.cakeVariantsSection.piecesTitle' | translate) : details?.filingSectionTitle)">
  @for (variant of variants; track variant.id) {
    <div class="mb-3">
      <label class="radio-item radio-primary"
             [class.checked]="variant.id=== activeVariant?.id">
        <input type="radio"
               value="{{variant.id}}"
               [checked]="variant.id === activeVariant?.id"
               [value]="variant"
               (change)="onSelect.emit(variant)"
               name="filling"
               required/>
        <span>
          {{variant.name}}
          @if (variant.priceDiff > 0 && !disabled && !isPieces) {
            <span>
              + {{variant.priceDiff | tryToDiscountPrice : discount: currency}}
            </span>
          }
          @if (!disabled && isPieces) {
            <span> - {{variant.price | currencyFormat: currency}}</span>
          }
          @if (variant.mostPopular) {
            <span class="ps-2 text-primary"> ({{'cakeBuilder.cakeVariantsSection.mostPopular' | translate}}) </span>
          }
        </span>
      </label>
    </div>
  }

  @if (details?.filingSectionHelpText) {
    <div class="help-text">
      {{details.filingSectionHelpText}}
    </div>
  }
</build-section>
